<fa-icon class="icon" [icon]="icon" [title]="title" [fixedWidth]="true" ></fa-icon>
